import React, { useCallback, useMemo, useContext, useRef } from 'react'
import { formatOccupantsAsGuests, formatOccupantsShort } from 'lib/occupancyUtils'
import { StandaloneFlightMenu } from 'components/Flights/FlightsSearch/SearchWidget/FlightSearchWidget'
import { FlightSearchWidgetActions } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'
import FlightSearchMenu from './FlightSearchMenu/FlightSearchMenu'
import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import FlightSearchWidgetDispatchContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetDispatchContext'
import SearchFormField from 'components/SearchV2/Components/SearchFormField/SearchFormField'
import FlightSearchTravellerSelectContent from './FlightSearchTravellerSelectContent'
import ModalContext from 'contexts/ModalContext'

interface Props {
  className?: string;
}

function FlightSearchTravellerSelectMobile({ className }: Props) {
  const state = useContext(FlightSearchWidgetStateContext)
  const dispatch = useContext(FlightSearchWidgetDispatchContext)

  const { occupants } = state
  const travellerLabel = useMemo(() => formatOccupantsShort(occupants), [occupants])

  const setActiveMenu = useCallback((activeMenu?: StandaloneFlightMenu) => {
    dispatch({ type: FlightSearchWidgetActions.SET_ACTIVE_MENU, activeMenu })
  }, [dispatch])

  const showModal = useContext(ModalContext)
  const handleOpen = useCallback(() => {
    setActiveMenu(StandaloneFlightMenu.occupants)
    let modalOccupants = { ...occupants }
    const updateModalOccupants = (nextOccupants: App.Occupants) => {
      modalOccupants = nextOccupants
    }

    showModal(<FlightSearchMenu
      title="Travellers"
      travellerLabel={travellerLabel}
      >
      <FlightSearchTravellerSelectContent
        occupants={modalOccupants}
        onOccupantsChange={updateModalOccupants}
      />
    </FlightSearchMenu>).finally(() => {
      dispatch({ type: FlightSearchWidgetActions.SET_OCCUPANTS, occupants: modalOccupants })
      setActiveMenu()
    })
  }, [dispatch, occupants, setActiveMenu, showModal, travellerLabel])

  const fieldValue = useMemo(() => formatOccupantsAsGuests(occupants), [occupants])

  const triggerRef = useRef<HTMLButtonElement>(null)

  return (<SearchFormField
    className={className}
    label="Travellers"
    required
    requiredErrorMessage="Please select children's ages"
    value={fieldValue}
    onClick={handleOpen}
    ref={triggerRef}
  />
  )
}

export default FlightSearchTravellerSelectMobile
